import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import './Header.css';

const Header = ({ onRegisterCustomer, onShowReturnModal, onPrintReceipt }) => {
  const { language, toggleLanguage, t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  
  // Handle clicks outside the dropdown to close it
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && 
          !dropdownRef.current.contains(event.target) &&
          buttonRef.current && 
          !buttonRef.current.contains(event.target)) {
        const dropdown = document.getElementById('order-actions-dropdown');
        if (dropdown && dropdown.style.display === 'block') {
          dropdown.style.display = 'none';
        }
      }
    }
    
    // Add the event listener
    document.addEventListener('mousedown', handleClickOutside);
    
    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="app-header">
      <div className="logo-container">
        {/* Replace with your actual logo */}
        <div className="logo">
          <span className="logo-text">Khabeertech</span>
          <span className="logo-subtext">POS System</span>
        </div>
      </div>
      <div className="header-controls">
        {user && (
          <div className="user-info">
            <span className="user-name">{user.name}</span>
            <span className="user-role">{user.role}</span>
          </div>
        )}
        {user?.role === 'cashier' && (
          <>
            <button className="header-btn register-customer-btn" onClick={onRegisterCustomer}>
              {t('cashier:customer.register.title')}
            </button>
            <div className="header-dropdown-container" style={{ position: 'relative', display: 'inline-block' }}>
              <button 
                ref={buttonRef}
                className="header-btn return-order-btn" 
                onClick={() => {
                  // Create a div element for our dropdown
                  const dropdown = document.getElementById('order-actions-dropdown');
                  if (dropdown) {
                    dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
                  }
                }}
                style={{
                  backgroundColor: '#dc2626', // red-600
                  color: 'white',
                  marginLeft: language === 'ar' ? '0' : '8px',
                  marginRight: language === 'ar' ? '8px' : '0'
                }}
              >
                {language === 'ar' ? 'خيارات الطلب' : 'Order Options'}
              </button>
              <div 
                id="order-actions-dropdown"
                ref={dropdownRef}
                style={{
                  display: 'none',
                  position: 'absolute',
                  backgroundColor: '#f9f9f9',
                  minWidth: '160px',
                  boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
                  zIndex: 1,
                  right: language === 'ar' ? 'auto' : '0',
                  left: language === 'ar' ? '0' : 'auto',
                  borderRadius: '4px',
                  marginTop: '2px'
                }}
              >
                <button 
                  onClick={() => {
                    document.getElementById('order-actions-dropdown').style.display = 'none';
                    onShowReturnModal();
                  }}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    textAlign: language === 'ar' ? 'right' : 'left',
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                    display: 'block',
                    direction: language === 'ar' ? 'rtl' : 'ltr',
                    color: '#333' // Adding dark text color for visibility
                  }}
                >
                  {language === 'ar' ? 'إرجاع طلب' : 'Return Order'}
                </button>
                <button 
                  onClick={() => {
                    document.getElementById('order-actions-dropdown').style.display = 'none';
                    if (onPrintReceipt) onPrintReceipt();
                  }}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    textAlign: language === 'ar' ? 'right' : 'left',
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                    display: 'block',
                    direction: language === 'ar' ? 'rtl' : 'ltr',
                    color: '#333' // Adding dark text color for visibility
                  }}
                >
                  {language === 'ar' ? 'طباعة الإيصال' : 'Print Receipt'}
                </button>
              </div>
            </div>
          </>
        )}
        <button className="language-toggle-btn" onClick={toggleLanguage}>
          {language === 'ar' ? 'English' : 'عربي'}
        </button>
        {user && (
          <button className="logout-btn" onClick={handleLogout}>
            {language === 'ar' ? 'تسجيل خروج' : 'Logout'}
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
